module.exports = __webpack_public_path__ + "img/LUB00343.42e224e5.svg";